module.exports = __webpack_public_path__ + "img/portraits_06_V.f650db97.jpg";